export default {
  deliveryDateCaption: {
    id: 'product_jp_item_reassurance_delivery_date_caption',
    defaultMessage: 'Order by {date} and',
  },
  deliveryDate: {
    id: 'product_jp_item_reassurance_delivery_date',
    defaultMessage: '{date, html} delivered',
  },
}
